import { useEffect, useRef } from 'react';

import { FaqSection, FinalCta, LandingFooter } from './components/closing-sections';
import { DeadlineSection } from './components/deadline-section';
import { FeaturesBento } from './components/features-bento';
import { FinanceSection } from './components/finance-section';
import { HeroSection } from './components/hero-section';
import { IntegrationsStrip } from './components/integrations-strip';
import { LandingHeader } from './components/landing-header';
import { DocumentsStory, FolderClipDefs, SecurityStory } from './components/photo-sections';
import { useReveal } from './hooks/use-reveal';
import './landing.css';

const TITLE = 'Sancus | CRM jurídico para escritórios de advocacia';
const DESCRIPTION =
  'Publicações do DJEN, prazos calculados pelo CPC, clientes, documentos e honorários em um só sistema. Crie sua conta gratuita.';

export function LandingPage() {
  const root = useRef<HTMLDivElement>(null);
  useReveal(root);

  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute('content') ?? '';

    document.title = TITLE;
    description?.setAttribute('content', DESCRIPTION);

    return () => {
      document.title = previousTitle;
      description?.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div ref={root} className="lp text-(--lp-ink) min-h-full bg-white font-sans antialiased">
      <FolderClipDefs />
      <a
        href="#conteudo"
        className="bg-(--lp-ink) fixed left-3 top-3 z-[60] -translate-y-24 rounded-lg px-4 py-2 font-medium text-white focus:translate-y-0"
      >
        Pular para o conteúdo
      </a>
      <LandingHeader />
      <main id="conteudo">
        <HeroSection />
        <IntegrationsStrip />
        <FeaturesBento />
        <DocumentsStory />
        <FinanceSection />
        <DeadlineSection />
        <SecurityStory />
        <FaqSection />
        <FinalCta />
      </main>
      <LandingFooter />
    </div>
  );
}
